import * as React from "react";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import colors from "assets/theme/base/colors";

import { ReactComponent as CameraIcon } from "assets/images/icons/camera.svg";
export default function UploadPersonImg() {
  const { secondary } = colors;
  return (
    <Stack direction="row" spacing={2} >
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        badgeContent={
          <CameraIcon
            style={{
              backgroundColor: secondary.main,
              padding: "3px",
              borderRadius: "50%",
              marginLeft: "4px",
            }}
          />
        }
      >
        <Avatar
          variant="square"
          sx={{borderRadius: "10.5px",width:"45px !important",height:"45px !important" }}

          alt="Travis Howard"
          src="/static/images/avatar/2.jpg"
        />
      </Badge>
    </Stack>
  );
}
